import { ApiModel } from '@composable-api/api.model'
import { ProductModel } from '@simploshop-models/product.model'

interface Attributes {
    [ProductsInPackageModel.ATTR_ITEMS]: ProductModel[]
    [ProductsInPackageModel.ATTR_URL_TEMPLATE]: string
}

interface Embeds {
}

export class ProductsInPackageModel extends ApiModel<Attributes, Embeds> {
    static key = 'ProductsInPackageModel'

    static readonly ATTR_ITEMS = 'items'
    static readonly ATTR_URL_TEMPLATE = 'url_template'

    get items() {
        return this._getAttribute(ProductsInPackageModel.ATTR_ITEMS, ProductModel)
    }

    get urlTemplate() {
        return this._getAttribute(ProductsInPackageModel.ATTR_URL_TEMPLATE)
    }
}
